import AdminInformationEdit from "~/pages/admin/Information/AdminInformationEdit.vue";
import AdminInformationList from "~/pages/admin/Information/AdminInformationList.vue";
import NyukyoshaList from "~/pages/admin/Nyukyosha/NyukyoshaList.vue";
import NyukyoshaDetail from "~/pages/admin/Nyukyosha/NyukyoshaDetail.vue";
import TopPage from "~/pages/top/TopPage.vue";
import InformationDetail from "~/pages/information/InformationDetail.vue";
import ShinjoshoEdit from "~/pages/keiyaku/shokai/ShinjoshoEditPage.vue";
import ShomeiEntryCheckPage from "~/pages/shomei/ShomeiEntryCheckPage.vue";
import InformationList from "~/pages/information/InformationList.vue";
import KeiyakushaList from "~/pages/admin/Keiyakusha/KeiyakushaList.vue";
import AccountDetail from "~/pages/admin/Keiyakusha/AccountDetail.vue";
import RsyncList from "~/pages/admin/Rsync/RsyncList.vue";
import AdminPasswordChangePage from "~/pages/admin/password/AdminPasswordChangePage.vue";
/**本部ユーザ用ルート*/
const headquartersRoutes = [
    //トップページ
    { name: "top", path: "top", component: TopPage },
    //お知らせ
    { name: "admin-information-list", path: "admin-information-list", component: AdminInformationList, meta: { adminOnly: true } },
    { name: "information-list", path: "information-list", component: InformationList },
    { name: "information-edit", path: "information-edit", component: AdminInformationEdit, meta: { adminOnly: true } },
    //入居者一覧、入居者情報詳細
    { name: "nyukyosha-list", path: "nyukyosha-list", component: NyukyoshaList, meta: { adminOnly: true } },
    { name: "nyukyosha-detail", path: "nyukyosha-detail", component: NyukyoshaDetail, meta: { adminOnly: true } },
    { name: "information-detail", path: "information-detail", component: InformationDetail },
    { name: "shinjosho-edit", path: "shinjosho-edit", component: ShinjoshoEdit },
    { name: "shomei-shinsei-entry-check", path: "shomei-shinsei-check", component: ShomeiEntryCheckPage },
    // 契約者一覧、アカウント編集
    { name: "keiyakusha-list", path: "keiyakusha-list", component: KeiyakushaList, meta: { adminOnly: true } },
    { name: "account-edit", path: "account-edit", component: AccountDetail, meta: { adminOnly: true } },
    // データ再同期
    { name: "resync", path: "resync", component: RsyncList, meta: { adminOnly: true } },
    // パスワード変更
    { name: "admin-password-change", path: "admin-password-change", component: AdminPasswordChangePage, meta: { adminOnly: true } }
];
export default headquartersRoutes;
